export const Functions = {
  create: false,
  delete: true,
  detail: false,
  search: true,
};

export const PageName = '龙舟成员列表';
